/* globals _ */

import Screen from './screen';

const { extend } = _;

export default Screen.extend( {
	events: {
		'click button[name="request"]': 'changeRequest',
		'input #ask': 'updateAsk',
	},

	listeners: extend( {}, Screen.prototype.listeners, {
		'model change:stops': 'renderCount',
		'model change:type': 'renderType',
		'model change:request': 'renderRequest',
	} ),

	changeRequest: function( e ) {
		this.model.set( 'request', e.currentTarget.value );
	},

	render: function() {
		Screen.prototype.render.apply( this, arguments );
		this.renderCount();
		this.renderType();
		this.renderRequest();
	},

	renderCount: function() {
		this.$el.toggleClass( 'has-stops', this.model.stops.length > 0 );
	},

	renderType: function() {
		var type = this.model.get( 'type' );
		this.$el.attr( 'data-type', type );
		this.$( 'button[name="type"]' ).removeClass( 'active' ).filter( `[value="${type}"]` ).addClass( 'active' );
	},

	renderRequest: function() {
		var request = this.model.get( 'request' );
		this.$el.attr( 'data-request', request );
		this.$( 'button[name="request"]' ).removeClass( 'active' ).filter( `[value="${request}"]` ).addClass( 'active' );
	},

	updateAsk: function( e ) {
		this.model.set( 'ask', e.currentTarget.value );
	},
} );
